import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { ContactWorkflowStatus, IContact } from 'clickNgo/entities/contact'

export const mapDataModelToIContact = (entryIdItem: DataModel): Partial<IContact> => {
  return {
    partnerId: entryIdItem.get('PartnerID'),
    parentPartnerId: entryIdItem.get('ParentPartnerID'),
    contactId: entryIdItem.get('ContactID'),
    country: entryIdItem.get('Country'),
    market: entryIdItem.get('Market'),
    countryOfBusiness: entryIdItem.get('CountryOfBusiness'),
    firstName: entryIdItem.get('FirstName'),
    lastName: entryIdItem.get('LastName'),
    email: entryIdItem.get('Email'),
    preferredLanguage: entryIdItem.get('PreferredLanguage'),
    onboardingRequestId: entryIdItem.get('OnboardingRequestId'),
    source: entryIdItem.get('Source'),
    sourceRequester: entryIdItem.get('SourceRequestor'),
    workflowStatus: ContactWorkflowStatus.New,
    mobilePhoneCode: entryIdItem.get('MobilePhone_Prefix'),
    mobilePhoneNumber: entryIdItem.get('MobilePhone'),
    workPhoneCode: entryIdItem.get('WorkPhone_Prefix'),
    workPhoneNumber: entryIdItem.get('WorkPhone'),
    salutation: entryIdItem.get('Salutation'),
    seniority: entryIdItem.get('Seniority'),
    isNeverCall: entryIdItem.get('NeverCall') === 'Y',
    isNeverEmail: entryIdItem.get('NeverEmail') === 'Y',
    hpRoles: entryIdItem.get('PR_HP_ROLE')?.split(';'),
    primaryJobRole: entryIdItem.get('PrimaryJobRole')?.split(';'),
    linkedInLink: entryIdItem.get('LinkedInLink'),
    photo: entryIdItem.get('Photo'),
    facebookLink: entryIdItem.get('FacebookLink'),
    twitterLink: entryIdItem.get('TwitterLink'),
    whatsAppLink: entryIdItem.get('WhatsAppLink'),
    relationshipStrength: entryIdItem.get('RelationshipStrength'),
    changeMindset: entryIdItem.get('ChangeMindset'),
    role: entryIdItem.get('Role'),
    contactStatus: entryIdItem.get('ContactStatus'),
    competitors: entryIdItem.get('Competitors'),
  }
}
